import { EmojiTheme } from './types';

export const EMOJI_THEMES: EmojiTheme[] = [
  {
    name: "Happy Rescue",
    emojis: ["🥰", "😍", "👻", "😈", "🙈", "🤗", "😘", "🫠"],
    backgroundColor: "#4CAF50",
    ufoStyle: "basic",
    description: "Free the happy emojis from alien captors!",
    unlockLevel: 1
  },
  {
    name: "Barnyard Rescue",
    emojis: ["🐄", "🐷", "🐔", "🐑", "🐴", "🐐", "🦆", "🐕"],
    backgroundColor: "#4CAF50",
    ufoStyle: "basic",
    description: "Save the farm animals from alien captors!",
    unlockLevel: 6
  },
  {
    name: "Ocean Rescue", 
    emojis: ["🐟", "🐙", "🦈", "🐳", "🐠", "🦀", "🐡", "🦞"],
    backgroundColor: "#2196F3",
    ufoStyle: "basic",
    description: "Rescue sea creatures from the depths!",
    unlockLevel: 11
  },
  {
    name: "Jungle Rescue",
    emojis: ["🐒", "🦁", "🐘", "🦒", "🐆", "🦓", "🦏", "🐊"],
    backgroundColor: "#8BC34A",
    ufoStyle: "armored",
    description: "Free the wild animals from stronger UFOs!",
    unlockLevel: 16
  },
  {
    name: "Travel Rescue",
    emojis: ["🛩️", "🛵", "🚂", "🚎", "🚗", "🚜", "🚁", "🛞"],
    backgroundColor: "#9C27B0", 
    ufoStyle: "stealth",
    description: "Save traveling mojis from stealth invaders!",
    unlockLevel: 21
  },
  {
    name: "Food Rescue",
    emojis: ["🍕", "🍔", "🍰", "🍪", "🍎", "🍌", "🍓", "🥑"],
    backgroundColor: "#FF9800",
    ufoStyle: "armored",
    description: "Protect Earth's delicious food from aliens!",
    unlockLevel: 26
  },
  {
    name: "Rare Creatures",
    emojis: ["🦄", "🐉", "🦋", "🐲", "🦅", "🦜", "🦩", "🦢"],
    backgroundColor: "#E91E63",
    ufoStyle: "stealth",
    description: "Rescue the rarest creatures in the universe!",
    unlockLevel: 31
  }
];

export const getThemeForLevel = (level: number): EmojiTheme => {
  // Find the appropriate theme based on level
  let selectedTheme = EMOJI_THEMES[0]; // Default to first theme
  
  for (const theme of EMOJI_THEMES) {
    if (level >= theme.unlockLevel) {
      selectedTheme = theme;
    } else {
      break;
    }
  }
  
  return selectedTheme;
};

export const getRandomEmojiFromTheme = (theme: EmojiTheme): string => {
  const randomIndex = Math.floor(Math.random() * theme.emojis.length);
  return theme.emojis[randomIndex];
};

export const getAllUnlockedThemes = (level: number): EmojiTheme[] => {
  return EMOJI_THEMES.filter(theme => level >= theme.unlockLevel);
};

export const getNextThemeUnlockLevel = (currentLevel: number): number | null => {
  const nextTheme = EMOJI_THEMES.find(theme => theme.unlockLevel > currentLevel);
  return nextTheme ? nextTheme.unlockLevel : null;
}; 